export class Customer {
    constructor({
        id,
        phoneNumber,
        phoneDigits,
        firstName,
        lastName,
        searchName,
        createdAt,
        lastOrderAt,
        totalOrders = 0,
        notes = ''
    }) {
        this.id = id;
        this.phoneNumber = phoneNumber;
        this.phoneDigits = phoneDigits;
        this.firstName = firstName;
        this.lastName = lastName;
        this.searchName = searchName;
        this.createdAt = createdAt;
        this.lastOrderAt = lastOrderAt;
        this.totalOrders = totalOrders;
        this.notes = notes;
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`.trim();
    }

    toJson() {
        return {
            phoneNumber: this.phoneNumber,
            phoneDigits: this.phoneDigits,
            firstName: this.firstName,
            lastName: this.lastName,
            searchName: this.searchName,
            createdAt: this.createdAt,
            lastOrderAt: this.lastOrderAt,
            totalOrders: this.totalOrders,
            notes: this.notes
        };
    }

    static fromFirebase(doc) {
        const data = doc.data();
        return new Customer({
            id: doc.id,
            phoneNumber: data.phoneNumber,
            phoneDigits: data.phoneDigits,
            firstName: data.firstName,
            lastName: data.lastName,
            searchName: data.searchName,
            createdAt: data.createdAt,
            lastOrderAt: data.lastOrderAt,
            totalOrders: data.totalOrders || 0,
            notes: data.notes || ''
        });
    }

    static createSearchFields(phoneNumber, firstName, lastName) {
        const phoneDigits = phoneNumber ? phoneNumber.replace(/\D/g, '') : '';
        const searchName = `${firstName} ${lastName}`.toLowerCase().trim();
        return { phoneDigits, searchName };
    }
}
